<script setup lang="ts">
import { LucideScale, LucideTrash2 } from 'lucide-vue-next'

const compareStore = useCompareStore()

const open = ref(false)

type CompareType = 'credits' | 'deposits' | 'cards'

const items = computed(() => {
  const entries: { type: CompareType; label: string; route: string }[] = [
    { type: 'credits', label: 'common.credits', route: '/compare/credits' },
    { type: 'deposits', label: 'common.deposits', route: '/compare/deposits' },
    { type: 'cards', label: 'common.cards', route: '/compare/cards' }
  ]
  return entries.filter((e) => compareStore.countByType[e.type] > 0)
})
</script>

<template>
  <DropdownMenu v-model:open="open">
    <DropdownMenuTrigger as-child>
      <Button variant="gray" size="icon" class="relative" as-child :aria-label="$t('compare.dropdown.title')">
        <button>
          <LucideScale class="size-5" />
          <ClientOnly>
            <span
              v-if="compareStore.totalCount > 0"
              class="absolute -right-1 -top-1 flex size-4 items-center justify-center rounded-full bg-blue-600 text-[10px] font-bold text-white"
            >
              {{ compareStore.totalCount }}
            </span>
            <template #fallback />
          </ClientOnly>
        </button>
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" class="w-56">
      <ClientOnly>
        <template v-if="compareStore.totalCount > 0">
          <DropdownMenuLabel>{{ $t('compare.dropdown.title') }}:</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <div
            v-for="item in items"
            :key="item.type"
            class="flex items-center justify-between px-2 py-1.5"
          >
            <NuxtLinkLocale
              :to="item.route"
              class="flex flex-1 items-center gap-2 text-sm hover:underline"
              @click="open = false"
            >
              <LucideScale class="size-4 text-gray-400" />
              <span>{{ $t(item.label) }}</span>
              <span
                class="ml-auto flex size-5 items-center justify-center rounded-full bg-blue-100 text-xs font-semibold text-blue-700"
              >
                {{ compareStore.countByType[item.type] }}
              </span>
            </NuxtLinkLocale>
            <Button
              variant="ghost"
              size="icon"
              class="ml-1 size-6 text-gray-400 hover:text-red-500"
              @click.prevent="compareStore.clear(item.type)"
            >
              <LucideTrash2 class="size-3.5" />
            </Button>
          </div>
        </template>
        <p v-else class="px-2 py-3 text-center text-sm text-gray-400">
          {{ $t('compare.empty_compare_list') }}
        </p>
      </ClientOnly>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
